import TagManager, { TagManagerArgs } from 'react-gtm-module';

export const initGTM = () => {

  const productionHost = 'professional-configurator.kwc.com';

  if (window.location.host === productionHost || window.location.hostname === productionHost) {
    const tagManagerArgs: TagManagerArgs = {
      gtmId: 'GTM-T6M5XGP'
    };
    TagManager.initialize(tagManagerArgs);
  }
};